import React from "react";

const RnRPlan = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("rnrPlan", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Rehabilitation and Resettlement (R&R) Plan</h3>
        <div className="form-group">
          <label className="required">
            Rehabilitation and Resettlement (R&R) Plan
          </label>
          <textarea
            type="text"
            name="rnrPlan"
            value={pfrFormData.rnrPlan.rnrPlan}
            onChange={handleInputChange}
            placeholder="Enter RnR Plan"
            required
          />
        </div>
      </div>
    </>
  );
};

export default RnRPlan;
